import React, {useEffect} from "react";
import MenuItem from "./MenuItem";
import {MainMenuWrapper, MenuButtonWrapper, MenuItemText, MenuItemWrapper,} from "./";
import {MAINMENU, MOBILEMENU} from "Consts/menuTypes";
import {useSelector} from "react-redux";
import {Arrow} from "BaseComponents/Icons/Svg";
import {BreadcrumbsLinkContainer} from "Components/Breadcrumbs/BreadcrumbsLinkContainer";
import styled from "styled-components";
import {useGlobal} from "reactn";
import {LanguageBox, LanguageLink} from "Components/LanguageBox";
import {HeaderButtonBookATour} from "Components/HeaderButtonBookATour/HeaderButtonBookATour";

export const MainMenu = ({
  MenuItems,
  ParentMenuLink,
  LoginPageUrl,
  LoginText,
  HideLanguageButton,
  ShowLanguageButtonAtBottom,
  ShowHeaderButtons,
  HeaderButtons,
  showChildNav,
  ParentMenu,
}) => {
  const { show } = useSelector(({ mobileMenu }) => mobileMenu);
  const [theme] = useGlobal("theme");
  const headline = ParentMenu?.Headline ? ParentMenu?.Headline : "";

  useEffect(() => {
    show
      ? document.body.classList.add("no-scroll")
      : document.body.classList.remove("no-scroll");
  }, [show]);

  const MainMenuContentWrapper = styled.div`
    display: flex;
    background-color: ${({ theme }) => theme.colors.white};
    flex-direction: column;
  `;

  let depth = 2;
  if (showChildNav) {
    const childrenNav = {
      Children: ParentMenu.Links,
      IsExpanded: true,
      IsActive: false,
      Name: ParentMenu.NavigationLinkName || ParentMenu.Headline,
      Url: ParentMenu.HeadlineUrl || null,
    };
    const inArray = MenuItems.Children.find(
      (element) =>
        element.Name === (ParentMenu.NavigationLinkName || ParentMenu.Headline)
    );
    if (!inArray) MenuItems.Children.unshift(childrenNav);
  }

  return (
    <MainMenuWrapper open={show}>
      {ParentMenuLink && (
        <MenuItemWrapper
          bgColor={theme.colors.lightgrey}
          Depth={depth}
          MenuType={MAINMENU}
          href={ParentMenuLink}
          bgColor={theme.colors.primary}
        >
          <BreadcrumbsLinkContainer {...{ show }}>
            {headline && (
              <MenuItemText
                Color="white"
                MenuType={MAINMENU}
                IsExpanded="false"
              >
                <Arrow
                  invert="rotate(180deg)"
                  size="15px"
                  color="white"
                  margin="0 0.5rem 0 0"
                  smalldisplay="block"
                />
                {headline}
              </MenuItemText>
            )}
          </BreadcrumbsLinkContainer>
        </MenuItemWrapper>
      )}
      {LoginPageUrl && (
        <MenuItemWrapper
          bgColor={theme.colors.lightgrey}
          borderTop={!ParentMenuLink}
          Depth={depth}
          MenuType={MAINMENU}
          href={LoginPageUrl}
        >
          <MenuItemText Color="black" MenuType={MAINMENU} IsExpanded="false">
            {LoginText}
          </MenuItemText>
          <MenuButtonWrapper IconSize="23px">
            <span className="element-link parent-menu-link">
              <i className="icon-key" aria-hidden="true"></i>
            </span>
          </MenuButtonWrapper>
        </MenuItemWrapper>
      )}
      {ShowHeaderButtons &&
        HeaderButtons?.length > 0 &&
        HeaderButtons.filter((c) => !c.MobileShowInHeader).map(
          (HeaderButton, index) => {
            return (
              <HeaderButtonBookATour
                key={index}
                {...HeaderButton}
                Depth={depth}
                MenuType={MOBILEMENU}
              />
            );
          }
        )}
      {!HideLanguageButton && !ShowLanguageButtonAtBottom && (
        <LanguageLink Depth={depth} MenuType={MOBILEMENU} />
      )}
      <MainMenuContentWrapper>
        {MenuItems.Children.map((page, i) => {
          let lastItem = MenuItems.Children.length - 1 == i;
          return (
            <MenuItem
              Depth={depth}
              {...page}
              Display={show}
              key={`desktop-menu-item-${i}`}
              MenuType={MAINMENU}
              LastItem={lastItem}
            />
          );
        })}
      </MainMenuContentWrapper>
      {!HideLanguageButton && ShowLanguageButtonAtBottom && (
        <>
          <LanguageLink Depth={depth} MenuType={MOBILEMENU} />
          <LanguageBox languages={languages} />
        </>
      )}
    </MainMenuWrapper>
  );
};
